"use client"

import { useState } from "react"
import { Modal } from "@/components/ui/modal"
import { Eye } from "lucide-react"

interface PitchSuggestionModalProps {
    isOpen: boolean
    onUseFundraising: () => void
    onContinuePresentation: () => void
    onClose: () => void
}

export function PitchSuggestionModal({
    isOpen,
    onUseFundraising,
    onContinuePresentation,
    onClose,
}: PitchSuggestionModalProps) {
    const [showPreview, setShowPreview] = useState(false)
    const samplePdf = "https://seedicon-dev-public-images.s3.ap-south-1.amazonaws.com/Haulix-Pitch-Deck.pdf"

    return (
        <>
            <Modal 
                isOpen={isOpen} 
                onClose={onClose}
                className="max-w-sm p-6"
                zIndex={61}
            >
                <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-2.5">
                        <div>
                            <h3 className="text-[15px] font-semibold text-slate-900 leading-tight">
                                Better results available
                            </h3>
                            <p className="text-[11px] text-slate-500 mt-0.5">Switch deck type?</p>
                        </div>
                    </div>
                </div>

                <p className="text-[13px] text-slate-600 leading-relaxed mb-4">
                    Your prompt looks like a pitch deck request. Our{" "}
                    <span className="font-semibold text-blue-600">Fundraising Pitch Deck</span>{" "}
                    type is built for investor presentations and gives significantly better results.
                </p>

                <div className="flex justify-center mb-6">
                    <button
                        type="button"
                        onClick={() => setShowPreview(true)}
                        className="flex items-center gap-1.5 text-[12px] text-blue-600 hover:text-blue-700 font-medium cursor-pointer transition-colors"
                    >
                        <Eye className="w-3.5 h-3.5" />
                        <span className="underline underline-offset-2">View sample fundraising deck</span>
                    </button>
                </div>

                <div className="flex flex-col gap-2">
                    <button
                        type="button"
                        onClick={onUseFundraising}
                        className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-[13px] font-semibold rounded-xl transition-colors cursor-pointer"
                    >
                        Use Fundraising Pitch Deck
                    </button>
                    <button
                        type="button"
                        onClick={onContinuePresentation}
                        className="w-full px-4 py-2.5 text-slate-600 hover:text-slate-800 hover:bg-slate-50 text-[13px] font-medium rounded-xl border border-slate-200 transition-colors cursor-pointer"
                    >
                        Continue with Presentation
                    </button>
                </div>
            </Modal>

            <Modal isOpen={showPreview} onClose={() => setShowPreview(false)} className="max-w-5xl p-0" zIndex={70}>
                <div className="aspect-[16/10] w-full">
                    {samplePdf ? (
                        <iframe src={samplePdf} className="w-full h-full rounded-2xl" title="PDF Preview" />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-slate-400 text-sm">
                            Preview not available yet
                        </div>
                    )}
                </div>
            </Modal>
        </>
    )
}
